import { render, staticRenderFns } from "./Itemdetails.vue?vue&type=template&id=0165cd7d&"
import script from "./Itemdetails.vue?vue&type=script&lang=js&"
export * from "./Itemdetails.vue?vue&type=script&lang=js&"
import style0 from "./Itemdetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports